import React from 'react';

import {
  ITravelExpensesOpenStatusPickerProps,
  TravelExpensesOpenStatusPicker,
} from '../../../../components/entity-picker/travel-expenses-open-status-picker/TravelExpensesOpenStatusPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type TravelExpensesOpenStatusCardProps = {
  title: string;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
} & ITravelExpensesOpenStatusPickerProps;

export const TravelExpensesOpenStatusCard: React.FC<
  TravelExpensesOpenStatusCardProps
> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  return (
    <FilterCard
      title={title}
      filterValue={value}
      filterValueSet={!!value}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={value ? () => onChange(null) : undefined}
    >
      <TravelExpensesOpenStatusPicker value={value} onChange={onChange} />
    </FilterCard>
  );
};
